import {formatDateStr} from "../util/date";

type TextFieldReadonlyProps = {
    label: string;
    value: string;
    hide?: boolean;
    noDiv?: boolean;
    small?: boolean;
    isDate?: boolean;
    labelAtTop?: boolean;
    fullRow?: boolean;
    multiRow?: boolean;
    valueOpacity?: boolean;
}

export function TextFieldReadonly({
                                      label,
                                      value,
                                      hide = false,
                                      noDiv = false,
                                      small = false,
                                      isDate = false,
                                      labelAtTop = false,
                                      fullRow = false,
                                      multiRow = false,
                                      valueOpacity = true,
                                  }: TextFieldReadonlyProps) {
    if (hide) {
        return noDiv ? <></> : <div/>;
    }

    if (value === "None" || value === "") {
        isDate = false;
    }

    return (
        <li className={`w-full flex text-base ${small ? "text-sm" : "pb-1"} ${labelAtTop ? "flex-col" : "justify-center items-center"} ${fullRow ? "col-span-2" : ""}`}>
            {labelAtTop &&
                <div className={`${small ? "text-xs" : ""} pr-4 text-left`}>
                    {label}
                </div>
            }
            {!labelAtTop &&
                <div className={`${small ? "text-xs" : ""} pr-4 text-right w-1/3`}>
                    {label}
                </div>
            }
            {
                multiRow &&
                <textarea
                    className={`${small ? "text-xs" : ""} ${valueOpacity? "opacity-50" : "" } border block cursor-not-allowed p-1 rounded ${labelAtTop ? "" : "w-2/3"}`}
                    readOnly
                    value={isDate ? formatDateStr(value) : value}
                />
            }
            {
                !multiRow &&
                <input
                    className={`${small ? "text-xs" : ""} ${valueOpacity? "opacity-50" : "" } border block cursor-not-allowed p-1 rounded ${labelAtTop ? "" : "w-2/3"}`}
                    disabled
                    readOnly
                    value={isDate ? formatDateStr(value) : value}
                />
            }
        </li>
    );
}
